import { AuthUser } from '@/core/Auth'
import { Gender } from '@/core/Programs'

export interface AuthState extends Omit<AuthUser, 'progress'> {
  progress: AuthUser['progress'] | null
}

export const initialState = (): AuthState => ({
  id: 0,
  email: '',
  emailVerifiedAt: '',
  name: 'ゲスト',
  point: 0,
  sex: Gender.NONE,
  passwordWarning: false,
  nickname: '',
  romanName: '',
  imagePath: null,
  isExemptedFromDowngrade: false,
  canPurchaseShortage: false,
  transactionFee: null,
  progress: null,
  isCorporateMember: false,
  pointSubscription: null,
  canceledPointSubscriptionNum: 0,
  age: null,
  prefecture: null,
  postalCode: null,
})
